import React, { useState, useEffect, useMemo, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Loader from "../ContantLoader";
import { getWorkflowLogs } from "api/WorkflowApi";
import Table from "../Table";
import { useDispatch, useSelector } from "react-redux";
import { setWorkflowLoading } from "ReduxStore/Slices/workflowSlice";

const WorkflowLogs = (props) => {
  let workflowId = sessionStorage.getItem("workflow_id");
  let name = sessionStorage.getItem("workflow_name");
  const [dataApi, setDataApi] = useState([]);
  const [totalPerson, setTotalPerson] = useState(0);

  const { workflowLoading } = useSelector((state) => state.workflowSetter);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setWorkflowLoading(true));
  }, []);
  const columns = useMemo(
    () => [
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Run Time",
        accessor: "runDateTime",
      },
      {
        Header: "State",
        accessor: "state",
      },
    ],
    []
  );
  const data = useMemo(() => dataApi, [dataApi]);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    dispatch(setWorkflowLoading(true));
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    await getWorkflowLogs(workflowId)
      .then((data) => {
        setDataApi(data.persons);
        setTotalPerson(data.numberOfPersons);
        dispatch(setWorkflowLoading(false));
      })
      .catch((e) => { });
  }, []);

  return (
    <div>
      <div className="page_heading">
        <button
          className="btn btn-sm"
          style={{ color: "#114169" }}
          onClick={() => props.history.push(`/admin/workflow/all_workflows`)}
        >{`< Back`}</button>
        <h2></h2>
        <h2>{name} Logs</h2>

        <p className="sm">
          This workflow has {totalPerson ? totalPerson : 0} person.
        </p>
      </div>
      <div></div>
      {
        <Table
          columns={columns}
          data={data}
          fetchData={fetchData}
          loading={workflowLoading}
        ></Table>
      }
    </div>
  );
};

export default WorkflowLogs;
